import { Award, TrendingUp, Star } from "lucide-react";

export function EmptyLeaderboardState() {
  return (
    <div className="text-center py-12">
      <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <Award className="h-10 w-10 text-purple-500" />
      </div>
      <h4 className="text-lg font-semibold text-gray-900 space-grotesk mb-2">
        Leaderboard coming soon!
      </h4>
      <p className="text-gray-500 space-grotesk mb-6 max-w-sm mx-auto">
        We're preparing an exciting leaderboard to showcase top referrers. Start making referrals now to secure your spot!
      </p>
      <div className="flex items-center justify-center gap-4 text-sm text-gray-400 space-grotesk">
        <div className="flex items-center gap-2">
          <TrendingUp className="h-4 w-4" />
          <span>Rankings</span>
        </div>
        <div className="flex items-center gap-2">
          <Star className="h-4 w-4" />
          <span>Rewards</span>
        </div>
        <div className="flex items-center gap-2">
          <Award className="h-4 w-4" />
          <span>Recognition</span>
        </div>
      </div>
    </div>
  );
}
